import * as React from 'react';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { PickersShortcutsItem } from '@mui/x-date-pickers';
import { LicenseInfo, DateRange, DateRangePickerDay, StaticDateRangePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
// import 'react-date-range/dist/styles.css';
// import 'react-date-range/dist/theme/default.css';
import { Moment } from 'moment';
import moment from 'moment';

LicenseInfo.setLicenseKey(
    MUIXLICENCE,
);

const shortcutsItems : Array<PickersShortcutsItem<DateRange<Moment>>> = [
    {
        label: 'Today',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().startOf('day'), moment().endOf('day')];
        },
    },
    {
        label: 'Yesterday',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')];
        },
    },
    {
        label: 'This Week',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().startOf('week'), moment().endOf('week')];
        },
    },
    {
        label: 'Last Week',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().subtract(7, 'day').startOf('week'), moment().subtract(7, 'day').endOf('week')];
        },
    },
    {
        label: 'Last 7 Days',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().subtract(7, 'day'), moment()];
        },
    },
    {
        label: 'Current Month',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().startOf('month'), moment().endOf('month')];
        },
    },
    {
        label: 'Last Month',
        getValue: () : DateRange<moment.Moment> => {
            return [moment().startOf('month').subtract(1, 'day').startOf('month'), moment().startOf('month').subtract(1, 'day')];
        },
    },
    { label: 'Reset', getValue: () : DateRange<moment.Moment> => [null, null] },
];

interface IDateRangeProps {
    // eslint-disable-next-line no-unused-vars
    onChange : (start : Moment | null, end : Moment | null, changedBy ?: 'start' | 'end') => void;
    start : Moment;
    end : Moment;
    parentPickerFunction ?: () => void;
    positionLeft ?: boolean;
    className ?: string;
}

/**
 * @param onChange - Function that handles changes to the date range. It receives the start and end dates as Moment objects, and an optional identifier indicating which date ('start' or 'end') was changed. Required.
 * @param start - The start date of the range, represented as a Moment object. Required.
 * @param end - The end date of the range, represented as a Moment object. Required.
 * @param parentPickerFunction - Optional function that can be called to trigger an action in the parent component when the date range changes.
 * @param positionLeft - Optional boolean that determines if the date picker dropdown should be aligned to the left. Default is false (aligned to the right).
 * @param className - Optional string for custom CSS class to apply additional styling to the date range picker.
 * 
 * @return {React.ReactElement} The React element for the Date Filter component.
 */
const DateRangePicker = (props : IDateRangeProps) : React.ReactElement => {

    const selectionRange = {
        startDate: props.start,
        endDate: props.end,
        key: 'selection',
    };

    const formatDayOfWeek = (day : string) : string => {
        // this is 100% a hackfix for a very strange issue where the day of the week is out by one on the calendar, if this ever gets resolved remove this
        const correctDayIndex = moment.weekdays().findIndex(x => x.includes(day));
        return correctDayIndex < 6 ? moment.weekdays()[correctDayIndex + 1].substring(0, 3) : moment.weekdays()[0].substring(0, 3);
    };

    const handleRangeChange = (ranges : DateRange<unknown>) : void => {
        const startdate = ranges[0];
        const enddate = ranges[1];
        props.onChange(startdate as moment.Moment, enddate as moment.Moment);
    };

    return (
        <div className={`${props.className ? props.className : ''} fdr flx1`}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={'en-GB'}>
                <StaticDateRangePicker
                    calendars={2}
                    dayOfWeekFormatter={formatDayOfWeek}
                    value={[selectionRange.startDate, selectionRange.endDate]}
                    onChange={handleRangeChange}
                    slots={{ day: DateRangePickerDay }}
                    slotProps={{
                        shortcuts: {
                            items: shortcutsItems,
                        },
                        actionBar: { actions: [] },
                    }}
                />
            </LocalizationProvider>
        </div>
    );
};

export default DateRangePicker;